// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import {FormMessageType} from "./FormMessageType";

export interface FormSetSubmitMessageDTO {
    readonly type  : FormMessageType.SET_SUBMIT;
}

export function isFormSetSubmitMessageDTO (value : any) : value is FormSetSubmitMessageDTO {

    return (
        !!value
        && value?.type === FormMessageType.SET_SUBMIT
    );

}
